import React, { ReactNode, useState } from 'react';
import { BaseAddonCategoryXlsContext } from './context';
import { BaseAddonCategoryXlsType } from 'utils/types';
const BaseAddonCategoryXlsProvider = ({ children }: { children: ReactNode }) => {
  const [addons, setAddons] = useState([] as any);
  const [mappedAddons, setMappedAddons] = useState([] as Partial<BaseAddonCategoryXlsType[]>);
  const [reviewedAddons, setReviewedAddons] = useState<string[]>([]);
  const [xlsFile, setXlsFile] = useState<File | null>(null);

  return (
    <BaseAddonCategoryXlsContext.Provider
      value={{
        xlsFile,
        setXlsFile,
        addons,
        setAddons,
        mappedAddons,
        setMappedAddons,
        reviewedAddons,
        setReviewedAddons
      }}>
      {children}
    </BaseAddonCategoryXlsContext.Provider>
  );
};

export default BaseAddonCategoryXlsProvider;
